import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from '@mui/material'
import MarkDownView from "./MarkDownView";
import { AppData } from '../../../Data/Models/AppData';
import ProjectCard from './ProjectCard'
import { mainCollection } from '../../../config/firebase';
import { getDocs, query, where } from 'firebase/firestore';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

function getViews(urls: string[]) {
    const imgs: { src: string }[] = []
    urls.forEach((src) => {
        imgs.push({ src })
    })
    return imgs
}

const Projects = () => {

    const [data, setData] = useState<AppData[]>([])
    const [open, setOpen] = React.useState(false);
    const [markDownData, setMarkDownData] = React.useState("");
    const [toggler, setToggler] = useState(false)
    const [togglerView, setTogglerView] = useState(false)
    const [images, setImages] = useState<{ src: string }[]>([])
    const [indexImg, setIndexImg] = useState<number>(0)

    useEffect(() => {
        const fetchData = async () => {
            const q = query(mainCollection, where("type", "==", 0))
            const querySnapshot = await getDocs(q);
            const myCollectionData = querySnapshot.docs.map((doc) => doc.data());
            setData(myCollectionData as AppData[])
            console.log(myCollectionData);
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (images.length > 0) {
            setToggler(true)
        }
    }, [images]);

    useEffect(() => {
        if (images.length > 0) {
            setToggler(true)
        }
    }, [togglerView]);

    return (
        <Box>
            <Typography variant='h5' sx={{ margin: "20px" }}>
                Android Apps
            </Typography>
            <Grid container>
                {data && data.map((card, index) => {
                    return (
                        <React.Fragment key={index}>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <ProjectCard appData={card} readMoreClick={() => {
                                    setOpen(true)
                                    setMarkDownData(card.markDown)
                                }} editClick={null}
                                    deleteClick={null}
                                    screenshotsClick={(index) => {
                                        setTogglerView(!togglerView)
                                        setIndexImg(index)
                                        setImages(getViews(card.screenshotUrls))
                                    }} />
                            </Grid>
                        </React.Fragment>
                    );
                })}

            </Grid>
            <MarkDownView toggle={[open, setOpen]} markDownData={markDownData} />
            <Lightbox
                open={toggler}
                close={() => setToggler(false)}
                slides={images}
                index={indexImg}
            />
        </Box>
    )
}

export default Projects
